export default "__VITE_ASSET__862cee4c__$_?react__"